// es6 collections polyfill
(function(e){function f(a,c){function b(a){if(!this||this.constructor!==b)return new b(a);this._keys=[];this._values=[];this._itp=[];this.objectOnly=c;a&&v.call(this,a)}c||w(a,"size",{get:x});a.constructor=b;b.prototype=a;return b}function v(a){this.add?a.forEach(this.add,this):a.forEach(function(a){this.set(a[0],a[1])},this)}function d(a){this.has(a)&&(this._keys.splice(b,1),this._values.splice(b,1),this._itp.forEach(function(a){b<a[0]&&a[0]--}));return-1<b}function m(a){return this.has(a)?this._values[b]:
void 0}function n(a,c){if(this.objectOnly&&c!==Object(c))throw new TypeError("Invalid value used as weak collection key");if(c!=c||0===c)for(b=a.length;b--&&!y(a[b],c););else b=a.indexOf(c);return-1<b}function p(a){return n.call(this,this._values,a)}function q(a){return n.call(this,this._keys,a)}function r(a,c){this.has(a)?this._values[b]=c:this._values[this._keys.push(a)-1]=c;return this}function t(a){this.has(a)||this._values.push(a);return this}function h(){(this._keys||0).length=this._values.length=
0}function z(){return k(this._itp,this._keys)}function l(){return k(this._itp,this._values)}function A(){return k(this._itp,this._keys,this._values)}function B(){return k(this._itp,this._values,this._values)}function k(a,c,b){var g=[0],e=!1;a.push(g);return{next:function(){var f,d=g[0];!e&&d<c.length?(f=b?[c[d],b[d]]:c[d],g[0]++):(e=!0,a.splice(a.indexOf(g),1));return{done:e,value:f}}}}function x(){return this._values.length}function u(a,c){for(var b=this.entries();;){var d=b.next();if(d.done)break;
a.call(c,d.value[1],d.value[0],this)}}var b,w=Object.defineProperty,y=function(a,b){return isNaN(a)?isNaN(b):a===b};"undefined"==typeof WeakMap&&(e.WeakMap=f({"delete":d,clear:h,get:m,has:q,set:r},!0));"undefined"!=typeof Map&&"function"===typeof(new Map).values&&(new Map).values().next||(e.Map=f({"delete":d,has:q,get:m,set:r,keys:z,values:l,entries:A,forEach:u,clear:h}));"undefined"!=typeof Set&&"function"===typeof(new Set).values&&(new Set).values().next||(e.Set=f({has:p,add:t,"delete":d,clear:h,
keys:l,values:l,entries:B,forEach:u}));"undefined"==typeof WeakSet&&(e.WeakSet=f({"delete":d,add:t,clear:h,has:p},!0))})("undefined"!=typeof exports&&"undefined"!=typeof global?global:window);

// define private
const map = new WeakMap();
window._ = key => {
	map.get(key) || map.set(key, {});
	return map.get(key);
}

import {Popup as UIPopup} from '/resources/js/modules/ui/Popup.js';

$(function(){
	// GNB
	(function(){
		const $header = $('#header');
		const $gnbSub = $header.find('.gnb-sub');
		
		$header.on('mouseover', function(e){
			if($(e.target).closest('.gnb').length > 0){
				$gnbSub.stop().slideDown(400);
			}
		});
		
		$header.on('mouseout', function(e){
			if($(e.target).closest('.gnb-sub').length > 0){
				$gnbSub.stop().slideUp(400);
			}
		});
	})();

	// location
	(function(){
		let pathname = location.pathname;
		let d1, d2, d3;

		const $allMenus = $('#all-menus');
		const $location = $('#location');
		const $depth1Menu = $location.find('.location-cont > .depth1 > li:not(.home)');
		const $depth2Menu = $location.find('.location-cont > .depth1 > li .depth2');
		
		// all-menus search path
		(function(){
			let $d1 = $allMenus.find('.depth1 > li').each(function(i){
				let $this = $(this);

				if($this.find('> a').attr('href') == pathname) {
					d1 = i;
					d2 = 0;
				}
				
				let $d2 = $this.find('.depth2 > li').each(function(j){
					let $this = $(this);

					if($this.find('> a').attr('href') == pathname) {
						d1 = i;
						d2 = j;
					}
					
					let $d3 = $this.find('.depth3 > li').each(function(k){
						let $this = $(this);

						if($this.find('> a').attr('href') == pathname) {
							d1 = i;
							d2 = j;
							d3 = k;
						}
					});
				});
			}); 
		})();

		// create location
		(function(){
			let $d1 = $allMenus.find('.depth1 > li');
			let d1Name = $d1.eq(d1).find('> a').text();
			$depth1Menu.eq(0).find('> a').text(d1Name);
			
			if(d1 !== undefined && $d1.eq(d1).css('display') != 'none'){
				$depth1Menu.eq(0).find('.depth2').css('visibility','visible');
			} else {
				$depth1Menu.eq(0).find('.depth2').css('visibility','hidden');
				$depth1Menu.eq(0).find('> a').css('background','inherit');
			}

			if(d2 !== undefined){
				let $d2 = $allMenus.find('.depth1 > li').eq(d1).find('.depth2 > li');
				
				let d2Name = $d2.eq(d2).find('> a').text();
				$depth1Menu.eq(1).show();
				$depth1Menu.eq(1).find('> a').text(d2Name);

				$d2.each(function(){
					let $l = $(this).clone();
					$l.find('.depth3').remove();
					$depth1Menu.eq(1).find('.depth2').append($l);
				});
			} else {
				$depth1Menu.eq(1).hide();
			}

			if(d3 !== undefined){
				let $d3 = $allMenus.find('.depth1 > li').eq(d1).find('.depth2 > li').eq(d2).find('.depth3 > li');
				
				let d3Name = $d3.eq(d3).find('> a').text();
				$depth1Menu.eq(2).show();
				$depth1Menu.eq(2).find('> a').text(d3Name);

				$d3.each(function(){
					$depth1Menu.eq(2).find('.depth2').append($(this).clone());
				});
			} else {
				$depth1Menu.eq(2).hide();
			}
			
			if(d1 == 1 && (d2 == 1 || d2 == 2 || d2 == 3)){
				$depth1Menu.eq(2).width(230);
				$depth1Menu.eq(2).find('.depth2 > li').width(230);
			}
		})();

		$depth1Menu.on('click', function(e){
			if($(e.target).closest('.depth2').length == 0) e.preventDefault();

			$depth2Menu.stop().slideUp();
			if($(this).find('.depth2').css('display') != 'block') $(this).find('.depth2').stop().slideDown();
		});
		
		$(window).on('scroll.location', function(){
			$depth2Menu.stop().slideUp(0);

			if($(window).scrollTop() > 160){
				if(!$location.hasClass('fixed')) $location.addClass('fixed');
			} else {
				$location.removeClass('fixed');
			}
		});
	})();

	// go top
	$('.btn-top').on('click', function(e){
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, {queue:false});
	});

	//datepicker
	(function(){
		window.createDatePicker();
		window.createMonthPicker();
	})();

	// image list
	(function(){
		const $imageList = $('.board-image-list .image-list ul li');
		$imageList.hover(function(){
			$(this).find('.cover').stop().fadeIn(400);
			$(this).find('.img').stop().animate({'scale':1.1}, {duration:400});

			$(this).find('.arrow .off i').stop().animate({left:'120%'}, {duration:400});
			$(this).find('.arrow .on').stop().animate({'opacity':1});
			$(this).find('.arrow .on i').stop().animate({left:'50%'}, {duration:400});
		}, function(){
			$(this).find('.cover').stop().fadeOut(400);
			$(this).find('.img').stop().animate({'scale':1}, {duration:400});

			$(this).find('.arrow .off i').stop().animate({left:'50%'}, {duration:400});
			$(this).find('.arrow .on').stop().animate({'opacity':0});
			$(this).find('.arrow .on i').stop().animate({left:'-120%'}, {duration:400});
		});
	})();

	// footer
	(function(){
		const $footer = $('#footer');
		const $btnGroup = $footer.find('.btn-group');
		const $companyGroupWrap = $('.company-group-wrap');
		const $btnClose = $companyGroupWrap.find('.btn-close');

		$btnGroup.on('click', function(e){
			e.preventDefault();

			if(!$(this).hasClass('on')){
				openGroupLayer();
			} else {
				closeGroupLayer();
			}
		});

		$btnClose.on('click', function(e){
			e.preventDefault();

			closeGroupLayer();
		});

		function closeGroupLayer(){
			$btnGroup.removeClass('on');
			$btnGroup.find('i').removeClass('ss-hyphen').addClass('ss-plus');
			$companyGroupWrap.hide();
		}

		function openGroupLayer(){
			$btnGroup.addClass('on');
			$btnGroup.find('i').removeClass('ss-plus').addClass('ss-hyphen');
			$companyGroupWrap.show();
		}
	})();

	// 공통 팝업 - 개인보호정책, 이메일 수집 거부, 전체 메뉴
	(function(){
		// 전체 메뉴
		new UIPopup({
			left:'center',
			top:'center',
			selector:'#all-menus',
			element:'',
			buttonSelector:'#header .btn-all-menus',
			position:'fixed',
			backgroundColor:'rgba(0,0,0,0.8)',
			defaultShow:false,
			show:function(){
				let h = $('#all-menus .all-menus-cont').height();
				$('#all-menus .all-menus-cont .depth1 > li').css('height', h);
			}
		});

		// 이메일 수집 거부
		new UIPopup({
			left:'center',
			top:'center',
			selector:'.popup.refuse-collection',
			element:'',
			buttonSelector:'#footer .policy .email',
			position:'fixed',
			backgroundColor:'rgba(0,0,0,0.8)',
			defaultShow:false
		});

		// 개인보호정책
		new UIPopup({
			left:'center',
			top:'center',
			selector:'.popup.privacy',
			element:'',
			buttonSelector:'#footer .policy .privacy',
			position:'fixed',
			backgroundColor:'rgba(0,0,0,0.8)',
			defaultShow:false
		});
	})();
});

// define Popup
window.definePopup = function(param){
	const popup = new UIPopup(param);
	return popup;
}

// createDatePicker
window.createDatePicker = function($parent=$(document)){
	$parent.find( ".datepicker" ).datepicker({
	    showOn: "button",
	    buttonImage: "/resources/img/ico-datepicker.gif",
	    buttonImageOnly: true,
	    dateFormat:'yy-mm-dd',
	    changeMonth: true,
	    changeYear: true,
	    yearRange: "-100:+0",
	    dayNamesMin: [ "일", "월", "화", "수", "목", "금", "토" ],
	    monthNames: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
	    monthNamesShort : ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        buttonText: "Select date"
    });
}

// createMonthPicker
window.createMonthPicker = function($parent=$(document)){
	$parent.find( ".monthpicker" ).monthpicker({
        pattern: 'yyyy-mm', // Default is 'mm/yyyy' and separator char is not mandatory
        /*selectedYear: 2014,
        startYear: 2008,
        finalYear: 2018,*/
        startYear: new Date().getYear() + 1900 - 100,
        finalYear: new Date().getYear() + 1900,
        openOnFocus: false,
        yearRange: "-100:+0",
        monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
    });

    $parent.find( ".monthpicker" ).each(function(){
    	let $this = $(this);
    	const $btn = $('<i class="btn-month-picker"></i>');
    	
    	$this.after($btn);
    	$btn.click(function(){
    		$this.monthpicker('show');
    	});
    });
}